import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';
import { register } from './loadingController';
import { handleHttpError } from './errorController';
import refreshAccessToken from '../auth/refreshToken';

const LoadingContext = createContext({ isLoading: false });

export const LoadingProvider = ({ children }) => {
  const [count, setCount] = useState(0);

  const start = useCallback(() => setCount(c => c + 1), []);
  const stop = useCallback(() => setCount(c => Math.max(c - 1, 0)), []);

  useEffect(() => {
    register(start, stop);
    const originalFetch = window.fetch;
    window.fetch = async (...args) => {
      start();
      try {
        let response = await originalFetch(...args);
        if (response.status === 401) {
          try {
            await refreshAccessToken();
            response = await originalFetch(...args);
          } catch (err) {
            handleHttpError(401);
            window.location.href = '/sign-in';
            throw err;
          }
        }
        if (!response.ok) {
          handleHttpError(response.status);
        }
        return response;
      } catch (err) {
        handleHttpError(err);
        throw err;
      } finally {
        stop();
      }
    };
    return () => {
      window.fetch = originalFetch;
    };
  }, [start, stop]);

  return (
    <LoadingContext.Provider value={{ isLoading: count > 0 }}>
      {children}
    </LoadingContext.Provider>
  );
};

export const useLoading = () => useContext(LoadingContext);
